import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';
import Criterium from '@hydra/common/criterium/Criterium';

export const EmailSecurity = ({ criterium }) => {
  const { data } = criterium;

  const textContent = data.length > 0
    ? 'email_security_ko'
    : 'email_security_ok';

  const content = <Translate content={textContent} />;

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

EmailSecurity.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.string)
  })
};

export default React.memo(EmailSecurity);
